import { Component, OnInit } from '@angular/core';
import { PermissionsEnum, Role, SystemComponents } from 'shared-lib';
import { RoleService } from 'shared-lib';
import { ToastrService } from 'ngx-toastr';
import { slideToggle } from '../../helpers/slidetoggle';
import { PermissionsService, DashboardConfiguration } from 'shared-lib';
import { EntityModelCustomizationService } from 'shared-lib';
import { EMCType } from '../../enums/emc-type';
import { EntityModelConfiguration } from '../../enums/entityModelConfiguration';
import { UtilitySharedService } from '../../shared/_services/utility-shared.service';

@Component({
  selector: 'app-role-and-permissions',
  templateUrl: './role-and-permissions.component.html',
  styleUrl: './role-and-permissions.component.scss',
  standalone: false,
  animations:[slideToggle]
})
export class RoleAndPermissionsComponent  implements OnInit {
  roles: Role[] = [];
  currentRole: Role = new Role();
  newRole: Role = new Role();
  initialPermissions: PermissionsEnum[] = [];
  updatedName: string = '';
  newsystemComponent: number = -1;
  saveChangesAllowed: boolean = false;
  public PermissionsEnum = PermissionsEnum;
  assetsCardExpanded: boolean;
  operationsCardExpanded: boolean = false;
  meterManagementCardExpanded: boolean = false;
  readingsCardExpanded: boolean = false;
  settingsCardExpanded: boolean = false;
  crudCardExpanded: boolean = false;
  assetsMobileCardExpanded: boolean = true;
  operationsMobileCardExpanded: boolean = true;
  meterManagementMobileCardExpanded: boolean = true;
  systemComponentDropdownOpened: boolean = false;
  public SystemComponent = SystemComponents;
  EMCType = EMCType;
  EntityModelConfiguration = EntityModelConfiguration;
  utilityId: number;

  // Entity Model Configurations
  EMCConfig_TS: EntityModelConfiguration[];
  EMCConfig_IS: EntityModelConfiguration[];
  EMCConfig_DS: EntityModelConfiguration[];
  EMCConfig_MvPole: EntityModelConfiguration[];
  EMCConfig_LvPole: EntityModelConfiguration[];
  EMCConfig_HvPole: EntityModelConfiguration[];
  
  constructor(
    private roleService: RoleService,
    private toastr: ToastrService,
    private emcService: EntityModelCustomizationService,
    public permissionsService: PermissionsService,
    private utilitySharedService: UtilitySharedService
  ) {}

  ngOnInit(): void {
    this.getRoles();
    this.saveChangesAllowed = false;
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
    this.getAssetsEntityModelConfigurations();
  }

  private getAssetsEntityModelConfigurations() {
    Object.values(EMCType).forEach(type => {
      this.emcService.getConfigurationByType({type: type as EMCType, utilityId: this.utilityId}).subscribe({
        next: (response: any) => {
          if (response?.body?.status == 200 || response?.body?.status == 'OK')
            var data = response?.body?.data;
            switch(type) {
              case EMCType.TransmissionStation:
                this.EMCConfig_TS = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
                break;
              case EMCType.InjectionSubstation:
                this.EMCConfig_IS = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
                break;
              case EMCType.DistributionSubstation:
                this.EMCConfig_DS = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
                break;
              case EMCType.MvPole:
                this.EMCConfig_MvPole = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
                break;
              case EMCType.Pole:
                this.EMCConfig_LvPole = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
                break;
              case EMCType.HvPole:
                this.EMCConfig_HvPole = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
                break;
              default: 
                break;
            }
        }
      })
    })
  }

  get dtMeterInstallationPermissions(): PermissionsEnum[] {
    const permissions = [
      PermissionsEnum.DtMeterInstallation_View,
      PermissionsEnum.DtMeterInstallation_CreateEdit,
      PermissionsEnum.DtMeterInstallation_Delete,
      PermissionsEnum.DtMeterInstallation_ApproveReject,
      PermissionsEnum.DtMeterInstallation_Recall,
      PermissionsEnum.DtMeterInstallation_AuthorizeMetering,
      PermissionsEnum.DtMeterInstallation_VendorAssignment,
      PermissionsEnum.DtMeterInstallation_DeclineReport,
    ];

    if (!this.permissionsService.hasDashboardConfigMeterApprovalAndRepayment) {
      return permissions;
    }

    return permissions.concat([
      PermissionsEnum.DtMeterInstallation_AcceptDecline,
      PermissionsEnum.DtMeterInstallation_ApproveMeter,
      PermissionsEnum.DtMeterInstallation_ApproveInvoice,
      PermissionsEnum.DtMeterInstallation_RecallAwaitingApproval,
      PermissionsEnum.DtMeterInstallation_AcknowledgeRepayment,
      PermissionsEnum.DtMeterInstallation_ViewMeterApproval,
      PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval,
      PermissionsEnum.DtMeterInstallation_ViewActiveRepayment,
      PermissionsEnum.DtMeterInstallation_ViewCompletedPayment,
    ]);
  }

  openAddNewRole(){
    this.newRole = new Role();
    this.newRole.systemComponent = SystemComponents.Undefined;
  }

  selectSystemComponent(sysComponent: SystemComponents) {
    this.newRole.systemComponent = sysComponent;
    this.systemComponentDropdownOpened = false;
  }

  toggleSystemComponentDropdown(){
    this.systemComponentDropdownOpened = !this.systemComponentDropdownOpened;
  }

  get selectedSystemComponentText(): string {
    if (this.newRole.systemComponent === SystemComponents.Undefined) {
      return 'ROLE_MANAGEMENT.SYSTEM_COMPONENT';
    }
    return this.mapSystemComponentName(this.newRole.systemComponent);
  }

  mapSystemComponentName(sysComponent: SystemComponents): string {
    switch (sysComponent) {
      case SystemComponents.Admin:
        return 'ROLE_MANAGEMENT.ADMIN';
      case SystemComponents.Mobile:
        return 'ROLE_MANAGEMENT.MOBILE';
      case SystemComponents.Undefined:
      default:
        return 'ROLE_MANAGEMENT.SYSTEM_COMPONENT';
    }
  }

  getRoles() {
    this.roleService.getAll().subscribe(
      (response) => {
        this.roles = response.body?.data;
        if (this.roles.length > 0)
          this.currentRole = JSON.parse(JSON.stringify(this.roles[0]));

        this.initialPermissions = [...this.currentRole.permissions];
      }, 
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  onSidebarItemSelected(id: number){
    const foundRole = this.roles.find(r => r.id === id);
    this.currentRole = foundRole ? JSON.parse(JSON.stringify(foundRole)) : new Role();
    this.initialPermissions = [...this.currentRole.permissions];

    this.checkChangeInPermissions();
  }

  save(){
    this.newRole.systemComponent = this.newsystemComponent as SystemComponents;
    if (this.newRole.name.length == 0) {
      this.toastr.error('Please, enter role name.');
      return;
    }
    if (this.newRole.systemComponent == -1) {
      this.toastr.error('Please, select system component.');
      return;
    }
    if (this.newRole.systemComponent == 1) {
      var x = localStorage.getItem('configuration');
      let configurations = x ? JSON.parse(x) : [];
      if (
        configurations.length == 1 &&
        configurations.includes(DashboardConfiguration.WorkOrder)
      ) {
        this.toastr.error(
          "Utility doesn't have any mobile configurations enabled."
        );
        return;
      }
    }

    this.newRole.permissions = []; // clear permissions
    this.roleService.save(this.newRole).subscribe(
      (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData.message);
          this.newRole = new Role();
          this.getRoles();

        } else {
          this.toastr.error(responseData?.message);
        }
      },
      (error) => {
        this.toastr.error('Error occured');
      }
    );
  }

  isChecked(listPermissions: any) {
    let checked = true;
    listPermissions.forEach((val: any) => {
      if (!this.currentRole.permissions.includes(val)) checked = false;
    });
    return checked;
  }

  onChangePermission(listPermissions: any, event: any = null) {
    if (
      listPermissions.includes(PermissionsEnum.MeterReading) ||
      this.currentRole.permissions.includes(PermissionsEnum.MeterReading)
    ) {
      this.currentRole.permissions = [];
    } 
    listPermissions.forEach((value: any) => {
      if (event != null) {
        if (!this.isChecked([value]) && event.target.checked == true)
          this.currentRole.permissions.push(value);
        else if (this.isChecked([value]) && event.target.checked == false)
          this.currentRole.permissions = this.currentRole.permissions.filter(
            (item: any) => item != value
          );
      } else {
        if (this.currentRole.permissions.includes(value))
          this.currentRole.permissions = this.currentRole.permissions.filter(
            (item: any) => item != value
          );
        else this.currentRole.permissions.push(value);
      }
    });

    this.checkChangeInPermissions();
  }

  checkChangeInPermissions(): void {
    const sortedInitial = [...this.initialPermissions].sort((a, b) => a - b);
    const sortedCurrent = [...this.currentRole.permissions].sort((a, b) => a - b);

 
    if (sortedInitial.length !== sortedCurrent.length) {
      this.saveChangesAllowed = true;
      return;
    }
    
    const areArraysEqual = sortedInitial.every((permission, index) => 
      permission === sortedCurrent[index]
    );
    
 
    this.saveChangesAllowed = !areArraysEqual;
  }

  saveChanges() {
    this.roleService.save(this.currentRole).subscribe(
      (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData.message);
          this.currentRole = new Role();
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      (error) => {
        this.toastr.error('Error occured');
      }
    );
  }

}
